import z from "zod/v4";

const LogoSchema = z.object({
  logo: z.string(),
  s3Url: z.string(),
});

type Logo = z.infer<typeof LogoSchema>;

export { LogoSchema };
export type { Logo };
